import { getStandardColumns } from '@townsquare/columns/hooks/use-shown-columns';
import { createRelayResource, RelayResourceConfig } from '@townsquare/relay-utils';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';

import DirectoryViewPeopleQuery, {
	type DirectoryViewPeopleQuery as DirectoryViewPeopleQueryType,
} from '../components/__generated__/DirectoryViewPeopleQuery.graphql';

import { getPeopleColumnsToFetchInTql } from './utils';

export const getPeopleDirectoryTableResourceQuery = (
	routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<DirectoryViewPeopleQueryType> => {
	const context = resourceContext as HomeResourceContext;
	const selectedStandardColumns = getStandardColumns('people', routerContext.query.columns);

	const peopleQuery = routerContext.query.tql || '';

	return {
		query: DirectoryViewPeopleQuery,
		variables: {
			peopleQuery,
			organisationId: context.workspace?.organisationId ?? context.orgId ?? '',
			cloudId: (context.collabContext?.rovoWorkspace || context.workspace?.cloudId) ?? 'None',
			...getPeopleColumnsToFetchInTql(selectedStandardColumns),
		},
		options: {
			fetchPolicy: 'store-and-network',
		},
	};
};

export const peopleDirectoryTableResource = createRelayResource<DirectoryViewPeopleQueryType>({
	getQuery: getPeopleDirectoryTableResourceQuery,
});
